import { postData } from '../../../../api/componentAPIs';
import CustomConfirmationDialog from '../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog';
import { useState, useEffect, useRef } from 'react';
import { withStyles, CircularProgress } from '@material-ui/core';
import { constants } from './constants';
import {
  getWarningMessageForDeleteFlow,
  getHolidayValidationDetails,
  getUnassignedHolidayWarningMessage
} from './utils';
import styles from './components/WarningConfirmationDialogStyles';

const DeleteHoliday = (props) => {
  const [holidayValidationMessage, setHolidayValidationMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [unassignedHolidayWarning, setUnassignedHolidayWarning] = useState('');
  const isMounted = useRef(true);

  useEffect(() => {
    validateHoliday();
    return () => {
      isMounted.current = false;
    };
  }, []);

  const validateHoliday = () => {
    getHolidayValidationDetails(props.selectedHolidayData.holidayId).then((response) => {
      if (!isMounted.current) {
        return;
      }
      handleHolidayValidationWarning(response?.data ?? []);
    });
  };

  const handleHolidayValidationWarning = (terminalToCustomerMappedData = []) => {
    let message = getWarningMessageForDeleteFlow(terminalToCustomerMappedData);
    if (message) {
      setHolidayValidationMessage(message);
    } else {
      const unassignedMessage = getUnassignedHolidayWarningMessage(
        props.selectedHolidayData,
        props.userAccessibleTerminals
      );
      setUnassignedHolidayWarning(unassignedMessage);
    }
    setIsLoading(false);
  };

  const deleteHoliday = () => {
    const holidayData = props.selectedHolidayData;
    if (!holidayData) {
      return;
    }
    const requestParams = {
      holidayId: holidayData.holidayId
    };
    postData('DeleteHoliday', requestParams).then(
      (response) => {
        if (response && response.status >= 200 && response.status < 400) {
          props.enqueueSnackbar(`Deleted holiday ${holidayData.holidayName} `, {
            variant: 'success'
          });
         props.onCloseHolidayDeletion();
        } else {
          handleError({ statusCode: response.status });
        }
      },
      (_error) => {
        handleError({});
      }
    );
  };

  const handleError = ({ statusCode }) => {
    if (statusCode !== 403) {
      props.enqueueSnackbar(`Error deleted holiday ${props.selectedHolidayData.holidayName} `, {
        variant: 'error'
      });
    }
    props.onCancel();
  };

  return (
    <>
      {props.selectedHolidayData && (
        <CustomConfirmationDialog
          title="Delete Holiday"
          cancelButtonLabel="Cancel"
          confirmButtonLabel="Remove"
          mode="danger"
          onConfirm={deleteHoliday}
          disabled={isLoading || !unassignedHolidayWarning && holidayValidationMessage}
          onCancel={props.onCancel}>
          <div className={props.classes.loaderContainer}>
            {isLoading && (
              <>
                <CircularProgress size={24} className={props.classes.loader} />
                <span>{constants.MESSAGE.HOLIDAY_VALIDATION_INPROGRESS}</span>
              </>
            )}
            {!isLoading && !unassignedHolidayWarning && holidayValidationMessage && (
              <div>
                {holidayValidationMessage}
                <br />
                <br />
                {constants.MESSAGE.CUSTOMER_ASSIGNED_DELETE}
              </div>
            )}
            {!isLoading && (unassignedHolidayWarning || !holidayValidationMessage) && (
              <div>
                <span className={props.classes.noCustomer}>
                  {constants.MESSAGE.NO_ASSIGNED_CUSTOMER}
                </span>
                <div className={props.classes.messageContainer}>
                  {`Are you sure you want to delete selected holiday "${props.selectedHolidayData.holidayName}" from holidayList?`}
                  <br />
                  <br />
                </div>
              </div>
            )}
            {!isLoading && unassignedHolidayWarning && (
              <div>
                {unassignedHolidayWarning}
              </div>
            )}
          </div>
        </CustomConfirmationDialog>
      )}
    </>
  );
};

export default withStyles(styles)(DeleteHoliday);
